// extracted by mini-css-extract-plugin
export default {"header":"styles_header__lm1EH","navigation":"styles_navigation__mLsXP","SignIn":"styles_SignIn__Q58QD","links":"styles_links__5-Lr8"};